import { useMutation } from "@apollo/client/react";

import { UPDATE_TEMPLATE_SHARING } from "../graphql/mutations/UpdateTemplateSharing";
export const useTemplateSharing = () => {
  const [updateTemplateSharing] = useMutation(
    UPDATE_TEMPLATE_SHARING,
  );

  const shareTemplate = async (
    template: { uuid?: string } | null,
    sharingType: string,
    sharedEmails: string[] | null = null,
  ) => {
    if (!template?.uuid) {
      throw new Error("Template not found");
    }

    await updateTemplateSharing({
      variables: {
        templateUuid: template.uuid,
        sharingType,
        sharedEmails,
      },
    });

    return true;
  };

  return {
    shareTemplate,
  };
};
